module.exports = __webpack_public_path__ + "img/zemin-login.8efe6f98.png";